import { apiClient } from '@/shared/lib/apiClient';

export interface ChatHistoryEntry {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatExpenseResult {
  id: string;
  expenseNumber: string;
  title: string;
  status: string;
  expenseDate: string;
  amount: number;
  currency: string;
  merchantName: string | null;
  categoryName: string | null;
}

export interface ChatReply {
  reply: string;
  expenses?: ChatExpenseResult[];
}

export async function sendChatMessage(message: string, history: ChatHistoryEntry[]): Promise<ChatReply> {
  // Local AI providers can take well over the app's default 30s API timeout
  // to respond, especially under GPU load — give chat its own, longer budget
  // instead of failing with a false "couldn't reach the assistant" error.
  const response = await apiClient.post('/chat/message', { message, history }, { timeout: 120000 });
  return response.data.data;
}
